// Shared line-level diff (LCS) used to render Before → After payload changes.
// Returns [{ t: 'same' | 'add' | 'del', s: <line> }] — 'del' = only in A, 'add' = only in B.
export function lineDiff(aText, bText) {
    const A = String(aText).split('\n'), B = String(bText).split('\n');
    const n = A.length, m = B.length;
    const dp = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0));
    for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--)
        dp[i][j] = A[i] === B[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    const out = []; let i = 0, j = 0;
    while (i < n && j < m) {
        if (A[i] === B[j]) { out.push({ t: 'same', s: A[i] }); i++; j++; }
        else if (dp[i + 1][j] >= dp[i][j + 1]) { out.push({ t: 'del', s: A[i] }); i++; }
        else { out.push({ t: 'add', s: B[j] }); j++; }
    }
    while (i < n) out.push({ t: 'del', s: A[i++] });
    while (j < m) out.push({ t: 'add', s: B[j++] });
    return out;
}
